/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { ChargeCreditCardRequest } from '../model/chargeCreditCardRequest';
import { ChargeCustomerACHRequest } from '../model/chargeCustomerACHRequest';
import { ChargeCustomerCreditCardRequest } from '../model/chargeCustomerCreditCardRequest';
import { ChargeCustomerStoredPaymentMethodRequest } from '../model/chargeCustomerStoredPaymentMethodRequest';
import { ChargeResponse } from '../model/chargeResponse';
import { PaymentGatewayConfig } from '../model/paymentGatewayConfig';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class ChargeApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public chargeBankAccountObservable: ChargeResponse | undefined = undefined;

    /**
     * Charges bank account for multiple invoices.
     * 
     * @param body 
     */
    @action
    public chargeBankAccount(body?: ChargeCustomerACHRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/charge/bankaccount`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeBankAccountObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public chargeCreditCardObservable: ChargeResponse | undefined = undefined;

    /**
     * Charges credit card for a single invoice.
     * 
     * @param body 
     */
    @action
    public chargeCreditCard(body?: ChargeCreditCardRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/charge`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeCreditCardObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public chargeCreditCardMultipleObservable: ChargeResponse | undefined = undefined;

    /**
     * Charges credit card for multiple invoices.
     * 
     * @param body 
     */
    @action
    public chargeCreditCardMultiple(body?: ChargeCustomerCreditCardRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/charge/multiple`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeCreditCardMultipleObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public chargeStoredPaymentMethodObservable: ChargeResponse | undefined = undefined;

    /**
     * Charges credit card for multiple invoices through stored credit card.
     * 
     * @param body 
     */
    @action
    public chargeStoredPaymentMethod(body?: ChargeCustomerStoredPaymentMethodRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<ChargeResponse> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<ChargeResponse>(
            `${this.basePath}/api/charge/storedpaymentmethod`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.chargeStoredPaymentMethodObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public paymentGatewayConfigObservable: PaymentGatewayConfig | undefined = undefined;

    /**
     * Get Paymentgateway config
     * 
          */
    @action
    public paymentGatewayConfig(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<PaymentGatewayConfig> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<PaymentGatewayConfig>(
            `${this.basePath}/api/charge/paymentgateway`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.paymentGatewayConfigObservable = response.data);
            }
            return response;
        });
    }

}
